exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/~/core-js/modules/_object-gops.js
// module id = ../../../../core-js/modules/_object-gops.js
// module chunks = 0